import React from 'react'
import { Button } from 'antd'
import { useTranslation } from 'next-i18next'
import styles from './ProjectFormButtonContinue.module.scss'

const ProjectFormButtonContinue: React.FC = () => {
  const { t } = useTranslation()

  return (
    <div className={styles.content}>
      <Button
        type='primary'
        htmlType='submit'
        className={styles.button}
        size={'large'}
      >
        {t('card.Continue')}
      </Button>
    </div>
  )
}

export default ProjectFormButtonContinue
